// extracted by mini-css-extract-plugin
export default {"body":"body-xD9Xz","emptyBody":"emptyBody-m0SU0","emptyBodyContent":"emptyBodyContent-Z0e1h","formGroup":"formGroup-FzDrg"};